var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"spinner",style:({ borderColor: _vm.color }),attrs:{"role":"status"}},[_c('span',{staticClass:"spinner__text"},[_vm._v("Loading...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }